import { type DeliveryNoteEventName } from '~/data/delivery';

import { i18n } from '~/utils';

import { type IconMetaphor } from '@vestigas/ui';

export const DELIVERY_NOTE_SIDEBAR_CONTENT = [
  'comments',
  'attachments',
] as const;

export const PARTY_I18N_MAP = () => ({
  buyer: i18n.t(($) => $.party.buyer, { ns: 'deliveryNotes' }),
  carrier: i18n.t(($) => $.party.carrier, { ns: 'deliveryNotes' }),
  on_behalf_buyer: i18n.t(($) => $.party.onBehalfBuyer, {
    ns: 'deliveryNotes',
  }),
  on_behalf_carrier: i18n.t(($) => $.party.onBehalfCarrier, {
    ns: 'deliveryNotes',
  }),
  on_behalf_recipient: i18n.t(($) => $.party.onBehalfRecipient, {
    ns: 'deliveryNotes',
  }),
  on_behalf_seller: i18n.t(($) => $.party.onBehalfSeller, {
    ns: 'deliveryNotes',
  }),
  on_behalf_supplier: i18n.t(($) => $.party.onBehalfSupplier, {
    ns: 'deliveryNotes',
  }),
  recipient: i18n.t(($) => $.party.recipient, { ns: 'deliveryNotes' }),
  seller: i18n.t(($) => $.party.seller, { ns: 'deliveryNotes' }),
  supplier: i18n.t(($) => $.party.supplier, { ns: 'deliveryNotes' }),
  trader: i18n.t(($) => $.party.trader, { ns: 'deliveryNotes' }),
});

export const SIGNATURE_ROLE_I18N_MAP = () => ({
  buyer: i18n.t(($) => $.signatureRole.buyer, { ns: 'deliveryNotes' }),
  carrier: i18n.t(($) => $.signatureRole.carrier, { ns: 'deliveryNotes' }),
  on_behalf_buyer: i18n.t(($) => $.signatureRole.onBehalfBuyer, {
    ns: 'deliveryNotes',
  }),
  on_behalf_carrier: i18n.t(($) => $.signatureRole.onBehalfCarrier, {
    ns: 'deliveryNotes',
  }),
  on_behalf_recipient: i18n.t(($) => $.signatureRole.onBehalfRecipient, {
    ns: 'deliveryNotes',
  }),
  on_behalf_seller: i18n.t(($) => $.signatureRole.onBehalfSeller, {
    ns: 'deliveryNotes',
  }),
  on_behalf_supplier: i18n.t(($) => $.signatureRole.onBehalfSupplier, {
    ns: 'deliveryNotes',
  }),
  recipient: i18n.t(($) => $.signatureRole.recipient, { ns: 'deliveryNotes' }),
  seller: i18n.t(($) => $.signatureRole.seller, { ns: 'deliveryNotes' }),
  supplier: i18n.t(($) => $.signatureRole.supplier, { ns: 'deliveryNotes' }),
  trader: i18n.t(($) => $.signatureRole.trader, { ns: 'deliveryNotes' }),
});

export const DELIVERY_NOTE_EVENT_DISPLAY = ({
  signatureRole,
}: {
  signatureRole?: SignatureRole;
}): Record<
  DeliveryNoteEventName,
  {
    icon: IconMetaphor;
    label: string;
  }
> => ({
  deliveryNoteAccepted: {
    icon: 'check',
    label: i18n.t(($) => $.eventName.deliveryNoteAccepted, {
      ns: 'deliveryNotes',
      signatureRole,
    }),
  },
  deliveryNoteArchived: {
    icon: 'archive',
    label: i18n.t(($) => $.eventName.deliveryNoteArchived, {
      ns: 'deliveryNotes',
    }),
  },
  deliveryNoteArrived: {
    icon: 'arrowForward',
    label: i18n.t(($) => $.eventName.deliveryNoteArrived, {
      ns: 'deliveryNotes',
    }),
  },
  deliveryNoteAssigned: {
    icon: 'assign',
    label: i18n.t(($) => $.eventName.deliveryNoteAssigned, {
      ns: 'deliveryNotes',
    }),
  },
  deliveryNoteCancelled: {
    icon: 'clear', // 'cancel' would be semantically correct, but is an ugly circular icon
    label: i18n.t(($) => $.eventName.deliveryNoteCancelled, {
      ns: 'deliveryNotes',
    }),
  },
  deliveryNoteCreated: {
    icon: 'add',
    label: i18n.t(($) => $.eventName.deliveryNoteCreated, {
      ns: 'deliveryNotes',
    }),
  },
  deliveryNoteEdited: {
    icon: 'edit',
    label: i18n.t(($) => $.eventName.deliveryNoteEdited, {
      ns: 'deliveryNotes',
    }),
  },
  deliveryNoteRejected: {
    icon: 'clear', // 'cancel' would be semantically correct, but is an ugly circular icon
    label: i18n.t(($) => $.eventName.deliveryNoteRejected, {
      ns: 'deliveryNotes',
      signatureRole,
    }),
  },
  deliveryNoteShared: {
    icon: 'share',
    label: i18n.t(($) => $.eventName.deliveryNoteShared, {
      ns: 'deliveryNotes',
    }),
  },
  deliveryNoteUnarchived: {
    icon: 'archive',
    label: i18n.t(($) => $.eventName.deliveryNoteUnarchived, {
      ns: 'deliveryNotes',
    }),
  },
  generic: {
    icon: 'more',
    label: i18n.t(($) => $.eventName.generic, { ns: 'deliveryNotes' }),
  },
});
